<div class="search-bar" [class.search-bar--open]="showPanel">
    <div class="search-bar__field" #searchField>
        <img
            class="search-bar__search-icon"
            src="assets/icons/search-icon.svg"
            alt=""
        />
        <input
            type="text"
            class="search-bar__input"
            [formControl]="searchTerm"
            [attr.aria-controls]="panelDomId"
            [attr.aria-expanded]="showPanel"
            aria-autocomplete="list"
            aria-haspopup="listbox"
            aria-label="Search input"
            [placeholder]="placeholder || 'Search brands, products, EANs'"
            (focus)="onFocus()"
            (keydown)="onKeydown($event)"
            autocomplete="off"
        />
        <button
            *ngIf="term"
            type="button"
            class="search-bar__clear"
            aria-label="Clear search"
            (click)="onClear($event)"
        >
            <img src="assets/icons/close-icon.svg" alt="" />
        </button>
    </div>

    <div
        *ngIf="showPanel"
        class="search-bar__panel"
        [id]="panelDomId"
        role="listbox"
        [ngStyle]="panelStyle"
    >
        <div *ngIf="loading && !hasSuggestions" class="search-bar__empty">
            Searching…
        </div>

        <div *ngIf="!loading && term.length >= 2 && !hasSuggestions" class="search-bar__empty">
            No matches for “{{ term }}”
        </div>

        <section *ngIf="filteredRecent.length" class="search-bar__section">
            <h3 class="search-bar__section-title">Recent searches</h3>
            <button
                type="button"
                class="search-bar__row search-bar__row--recent"
                *ngFor="let item of filteredRecent; let i = index"
                role="option"
                [class.search-bar__row--active]="activeIndex === i"
                (mousedown)="selectRecent(item, $event)"
            >
                <img src="assets/icons/search-history.svg" alt="" />
                <span>{{ item }}</span>
            </button>
        </section>

        <section *ngIf="brands.length" class="search-bar__section">
            <h3 class="search-bar__section-title">Brands</h3>
            <button
                type="button"
                class="search-bar__row search-bar__row--brand"
                *ngFor="let brand of brands; trackBy: trackBrand; let i = index"
                role="option"
                [class.search-bar__row--active]="activeIndex === filteredRecent.length + i"
                (mousedown)="selectBrand(brand, $event)"
            >
                <span class="search-bar__brand-name">
                    <span
                        *ngFor="let part of highlight(brand.name)"
                        [class.search-bar__match]="part.match"
                    >{{ part.text }}</span>
                </span>
                <span class="search-bar__brand-count" *ngIf="brand.count > 0">{{ brand.count }} products</span>
            </button>
        </section>

        <section *ngIf="products.length" class="search-bar__section">
            <h3 class="search-bar__section-title">Products</h3>
            <button
                type="button"
                class="search-bar__row search-bar__row--product"
                *ngFor="let product of products; trackBy: trackProduct; let i = index"
                role="option"
                [class.search-bar__row--active]="activeIndex === filteredRecent.length + brands.length + i"
                (mousedown)="selectProduct(product, $event)"
            >
                <div class="search-bar__thumb">
                    <img
                        *ngIf="hasImage(product); else noImage"
                        [src]="product.productAsset?.preview | productImageSrc : 'thumb' : product.productAsset?.id"
                        vsfFallbackSrc
                        [alt]="product.productName"
                    />
                    <ng-template #noImage>
                        <img src="assets/icons/venduro-favicon.svg" alt="" />
                    </ng-template>
                </div>
                <div class="search-bar__product-main">
                    <div class="search-bar__product-name">
                        <span
                            *ngFor="let part of highlight(product.productName)"
                            [class.search-bar__match]="part.match"
                        >{{ part.text }}</span>
                    </div>
                    <div class="search-bar__product-meta" *ngIf="productMeta(product)">
                        {{ productMeta(product) }}
                    </div>
                </div>
                <div class="search-bar__product-price" *ngIf="product.cheapestVariant?.priceWithTax != null">
                    <span>from</span>
                    <strong>{{ product.cheapestVariant?.priceWithTax | formatPrice }}</strong>
                </div>
            </button>
        </section>
    </div>
</div>
